import React from 'react'
import PropTypes from 'prop-types'
import { Tag } from '@offerzen/pinata'

import styles from './styles'

const RequirementTag = ({ text }) => {
  return <Tag className={styles.tag} text={text} theme="light" size="small" />
}

RequirementTag.propTypes = {
  text: PropTypes.string,
}

export default RequirementTag
